import { Component } from '@angular/core'
import { File } from 'depoto-core/src/entities'
import { CategoryTreeType } from '../../../models'
import { CoreService, NotificationService } from '../../../services'
import { SchemaUtil, getThumbUrl as imageGetThumbUrl } from '../../../utils'
import { ProductDetailService } from '../../../services/product-detail.service'
import * as Sentry from '@sentry/angular-ivy'
import { TranslateService } from '@ngx-translate/core'
import { FileUtilService } from '../../../utils/file-util.service'

@Component({
  selector: 'product-images',
  templateUrl: './product-images.component.html',
  styleUrls: ['product-images.component.scss'],
})
export class ProductImagesComponent {
  files: File[] = []
  progress = 0
  progressFiles = 0
  public categoryTreeTypeEnum = CategoryTreeType

  constructor(
    private core: CoreService,
    private notificationService: NotificationService,
    private translateService: TranslateService,
    public productDetailService: ProductDetailService,
    private fileUtilService: FileUtilService,
  ) {}

  async onSelect(event) {
    const enabledMimeTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif']
    const files = event.addedFiles.filter(f => enabledMimeTypes.includes(f.type))
    this.files.push(...files)
    await this.updateProductImages()
  }

  onRemove(event) {
    this.files.splice(this.files.indexOf(event), 1)
  }

  async updateProductImages() {
    this.productDetailService.loading = true
    const files = []
    this.progress = 0
    this.progressFiles = 0
    try {
      for (const f of this.files) {
        const processedFile = await this.fileUtilService.processUploadedFileToBase64(f)
        files.push(processedFile)
        await this.core.services.file.create(processedFile, this.productDetailService.product.id)
        this.progressFiles += 1
        this.progress = (100 / this.files.length) * this.progressFiles
      }
      this.notificationService.success(this.translateService.instant('alert.image.added'))
      const p = await this.core.services.product.getById(
        this.productDetailService.product.id,
        SchemaUtil.productFilesAndImages,
      )
      this.files = []
      this.productDetailService.product.images = [...p.images]
      this.productDetailService.product.mainImage = p.mainImage
      this.progress = 0
      this.progressFiles = 0
    } catch (err) {
      console.log(err)
    } finally {
      this.productDetailService.loading = false
    }
  }

  async removeImage(image: File) {
    if (!confirm(this.translateService.instant('product-images.delete.confirmation'))) {
      return
    }
    try {
      const result = await this.core.services.file.delete(image)
      if (!result) {
        this.notificationService.success(this.translateService.instant('alert.image.deleted'))
        this.productDetailService.product.images = this.productDetailService.product.images.filter(
          img => img.id !== image.id,
        )
        if (image.main) {
          this.productDetailService.product.mainImage = null
        }
      }
    } catch (err) {
      console.log(err)
    }
  }

  getThumbUrl(image: File, format: 'w135wp' | 'w2048wp' = 'w135wp'): string {
    return imageGetThumbUrl(image, format)
  }

  get product() {
    return this.productDetailService.product
  }
}
